import Vue from 'vue';
import Store from '@/store';

export const API_NAME = {
  getPageInfo: '/web/template/getPageInfo',
  doTask: '/web/template/doTask',
  queryRewardType: '/web/reward/queryType',
  getAwards: '/web/reward/query',
  withdraw: '/web/reward/takeCash',
  address: '/web/reward/queryGoodsAddress',
  getShareCode: '/web/invitation/shareCode',
  reportInvited: '/web/invitation/addInvitee',
  saveAddress: '/web/reward/addGoodsAddress',
  getCouponDetail: '/web/reward/queryRightDetail',
  checkStudentAuth: '/web/student/check'
};
const getCommonData = () => {
  return {
    locationInfo: Store.state.app && Store.state.app.locationObj
  };
};

// 奖励页接口固定的 label 参数，用于区分其他活动
const AwardLabelParam = {
  label: ''
};

const doBasePost = (api, data = {}) => {
  return Vue.prototype.$request.post(
    api,
    {
      ...getCommonData(),
      ...data
    },
    {
      headers: {
        'x-reqe1f2a3b4': 'true', // 启用请求加密
        'x-accrespf5g6h7i8': 'false' // 启用响应解密
      }
    }
  );
};

export const getPageInfo = code => {
  return doBasePost(API_NAME.getPageInfo, {
    code
  });
};

export const checkStudentAuth = code => {
  return doBasePost(API_NAME.checkStudentAuth, {
    code
  });
};

export const submitDraw = data => {
  return doBasePost(API_NAME.doTask, data);
};

export const doTask = data => {
  return doBasePost(API_NAME.doTask, data);
};

export const queryRewardType = () => {
  return doBasePost(API_NAME.queryRewardType, AwardLabelParam);
};

export const getMyAwards = (data = {}) => {
  return doBasePost(API_NAME.getAwards, {
    ...data,
    ...AwardLabelParam,
    code: Store.state.global.actName
  });
};

export const submitWithdraw = data => {
  return doBasePost(API_NAME.withdraw, {
    ...data,
    ...AwardLabelParam
  });
};

export const getUserAddress = () => {
  return doBasePost(API_NAME.address);
};

export const fetchShareCode = data => {
  return doBasePost(API_NAME.getShareCode, data);
};

export const reportInvited = data => {
  return doBasePost(API_NAME.reportInvited, data);
};

export const fetchCounponDetail = data => {
  return doBasePost(API_NAME.getCouponDetail, data);
};
